module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd-wap-integral"
  }, [_c('section', {
    staticClass: "infomation"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    staticClass: "f13"
  }, [_vm._v("获取积分")]), _vm._v(" "), _c('p', {
    staticClass: "f10"
  }, [_vm._v("学习课程,兑换书籍")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/integral/icon_ruhehuodejifen_jifenshangcheng.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n      积分是海渡职校诚挚回报学员的一种方式,是学员财富的象征。目前可使用积分兑换各类课程与实物书籍,均在对应课程栏目与积分商城功能模块下进行。后期我们将扩大积分的使用范围,敬请期待。\n    ")])]), _vm._v(" "), _c('section', {
    staticClass: "method"
  }, [_c('div', {
    staticClass: "title f13"
  }, [_vm._v("如何获取积分?")]), _vm._v(" "), _c('h3', {
    staticClass: "title_x"
  }, [_vm._v("新用户任务")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("绑定手机"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(首次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("50")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("设置头像"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(首次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("50")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("补充资料")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("100")]), _vm._v("积分")])])]), _vm._v(" "), _c('h3', {
    staticClass: "title_x"
  }, [_vm._v("每日任务")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("签到"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(当日首次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("10")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("课程分享"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日上限3次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("20")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("课程评论"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日上限3次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("20")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("圈子发布"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日首次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("20")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("圈子发布"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日第二次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("10")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("圈子发布"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日第三次及以上)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("5")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("圈子评论"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日上限5次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("3")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("圈子点赞"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日上限5次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("2")]), _vm._v("积分")])])]), _vm._v(" "), _c('h3', {
    staticClass: "title_x"
  }, [_vm._v("活动任务")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("获取勋章"), _c('span', {
    staticClass: "f9"
  })]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("200")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("月度赛投票"), _c('span', {
    staticClass: "f9"
  }, [_vm._v("(每日上限3次)")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("10")]), _vm._v("积分")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("邀请新用户")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', [_vm._v("400")]), _vm._v("积分")])])])]), _vm._v(" "), _c('section', {
    staticClass: "task"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我的任务")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("\n      每天签到都有积分拿;积分获取在\""), _c('span', [_vm._v("个人中心")]), _vm._v("\"->\""), _c('span', [_vm._v("我的任务")]), _vm._v("\"中。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/integral/img_jifenruhehuode.png"),
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30681472","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Integral.vue
// module id = 320
// module chunks = 1